import { type IReactionDisposer, makeAutoObservable, reaction } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import type { IResponseFullAICallingAgent, IResponseTemplate } from 'entities/AICalling/api/types'
import { TextToSpeechWidgetStore } from 'widgets/TextToSpeech'
import { GreetingVoiceConfigStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/Greeting/store/GreetingVoiceConfigStore'

export class GreetingStore {
  textToSpeechWidgetStore
  constructor(
    readonly entities: IEntitiesStore,
    readonly parent: {
      response?: IResponseFullAICallingAgent | null
      template?: IResponseTemplate
    }
  ) {
    const message = parent.response
      ? parent.response?.greeting_message || ''
      : parent.template?.greeting_message || ''

    this.textToSpeechWidgetStore = new TextToSpeechWidgetStore(
      {
        type: 'view',
        message,
        voiceId: parent.response?.voice,
        getConfigStore: (parent) => new GreetingVoiceConfigStore(parent),
      },
      this.entities
    )
    makeAutoObservable(this)
  }

  init = () => {
    this.reactionTemplate()
    return () => {
      this._disposeReactionTemplate?.()
    }
  }

  private _disposeReactionTemplate: IReactionDisposer | null = null
  reactionTemplate = () => {
    this._disposeReactionTemplate?.()
    this._disposeReactionTemplate = reaction(
      () => this.parent.template,
      (template) => {
        if (!template) return
        this.textToSpeechWidgetStore.setMessageData({
          message: template.greeting_message,
          isFocus: false,
          isReplace: true,
          attachments: [],
        })
      }
    )
  }

  get params() {
    return {
      greeting_message: this.textToSpeechWidgetStore.text || '',
      voice: this.textToSpeechWidgetStore.params.voiceId,
    }
  }

  get error() {
    return this.textToSpeechWidgetStore.error
  }
  setError = (error: string) => {
    this.textToSpeechWidgetStore.setValidError(error)
  }

  checkValidate = () => {
    let validate = true
    if (!this.params.voice) {
      validate = false
      this.setError('Voice cannot be empty')
    }
    if (!this.params.greeting_message) {
      validate = false
      this.setError('Message cannot be empty')
    }
    return validate
  }
}
